$(document).ready(function(){

  setTimeout(function(){
    $('.text-with-image-slider').flickity({
      // options
      cellAlign: 'left',
      cotain: true,
      autoPlay: 3000
    });

  },1000);

  $('.sf__vehicles__option:nth-child(1) select').focus(function(){
    $('.vehicle-pop-up').removeClass('pop-up-scroll-center');
  });

  $("body").on("focus", '.seatshop-ymms-selector .sf__vehicles__options select[name="year"]', function(){
    $(this).find("option:nth-child(2").text('1994 (earliest available)');
  });

  $("body").on("focus", '.seatshop__filters__ymms .sf__vehicles__options select[name="year"]', function(){
    $(this).find("option:nth-child(2").text('1994 (earliest available)');
  });

  $('.sf__vehicles__option:nth-child(2) select').focus(function(){
    $('.vehicle-pop-up').removeClass('pop-up-scroll-center');
  });


  $('.sf__vehicles__option:nth-child(3) select').focus(function(){
    var scroll = $(window).scrollTop();
    if(scroll == 0)$('.vehicle-pop-up').addClass('pop-up-scroll-center');
  });

  $('.sf__vehicles__option:nth-child(4) select').focus(function(){
    $('.vehicle-pop-up').removeClass('pop-up-scroll-center');
  });

  var position = $(window).scrollTop();


  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if(scroll <= 0) {
        $('.vehicle-pop-up').removeClass('pop-up-scroll-down');
        $('.vehicle-pop-up').addClass('pop-up-scroll-up');
      } else {
        $('.vehicle-pop-up').removeClass('pop-up-scroll-up');
        if(scroll > position) {
          $('.vehicle-pop-up').addClass('pop-up-scroll-down');
        } else {
          $('.vehicle-pop-up').removeClass('pop-up-scroll-down');
        }
      }

      position = scroll;
  });

    //BEGIN
    $(".faq-section .accordion__title").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);

      if (!$this.hasClass("accordion-active")) {
          $(".accordion__content").slideUp(400);
          $(".accordion__title").removeClass("accordion-active");
      }

      $this.toggleClass("accordion-active");
      $this.next().slideToggle();
    });
    //END


  // Use native capture phase to intercept clicks that might be stopped by Judge.me
  document.addEventListener('click', function(e) {
    const badge = e.target.closest('.stamped-product-reviews-badge, .jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge');
    if (badge) {
      const reviewsTab = document.querySelector('.product__tabs__tabs li[data-tab="reviews"]');
      if (reviewsTab) {
        reviewsTab.click(); 
        
        // Small delay to ensure the tab content is visible before scrolling
        setTimeout(function() {
          const tabsContainer = document.querySelector('.product__tabs');
          if (tabsContainer) {
            const offset = 100;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = tabsContainer.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 50);
      }
    }
  }, true);

});

function onClick(element) {
  document.getElementById("img01").src = element.src;
  document.getElementById("modal01").style.display = "block";
  document.body.style.overflowY = 'hidden';
}

function onCloseModal(modal) {
  modal.style.display='none';
  document.body.style.overflowY = 'scroll';
}

$('.text-with-image-slider').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  autoPlay: 3000
});

// Trigger only if the screen is not touchable
if(!('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0)) {
  $('.header__inline-menu details-disclosure').hover(
      function () {
        $(this).find('details').prop('open', true)
      },
      function () {
        $(this).find('details').prop('open', false)
      }
  );
}

/**
 * // we update the content on the fly after every page load, to keep consistency.
 */
$(document).ready( function() {
    let $counter = $('#cart-icon-bubble');
    $.get('/?sections=cart-icon-bubble', function(sections) {
      $counter.html(sections['cart-icon-bubble']);
    }, 'json');
});

// Trigger the click event on the cant-find link when the user selects the "Can't find your make?" option
document.addEventListener('change', function(event) {
  const select = event.target.closest('select');
  if (select && select.value === 'cant-find') {
    const cantFindLink = document.querySelector('.cant-find');
    cantFindLink.click();
  }
});

// Native discount JS
class DiscountPopupStatic extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('.accordion-button');
    this.localStorageKey = 'discount-popup-closed';

    // Progress bar
    this.progressBar = this.querySelector('.threshold-bar__progress');

    // In progress element
    this.inProgressElement = this.querySelector('.inprogress-desc');

    // // Section Settings
    // this.sectionSettings = JSON.parse(this.getAttribute('data-section-settings'));

    // Apply saved state
    const isClosed = localStorage.getItem(this.localStorageKey) === 'true';
    if (isClosed) {
      this.classList.add('closed');
    }

    // Apply cart-has-items class if cart has items
    this.toggleButton.addEventListener('click', this.onButtonClick.bind(this));

    // Listen for cart:updated event
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));

    // Dispatch cart:updated event
    // const event = new CustomEvent('cart:updated', { bubbles: true });
    // document.dispatchEvent(event);
  }

  onButtonClick(event) {
    this.classList.toggle('closed');

    // Save the current state to localStorage
    const isClosed = this.classList.contains('closed');
    localStorage.setItem(this.localStorageKey, isClosed.toString());
  }


  onCartUpdated(event) {
    // Fetch Cart from cart.js
    fetch('/cart?view=discount-popup').then(res => res.json())
      .then(cart => {
        if (cart.item_count > 0) {
          this.classList.add('cart-has-items');
        } else {
          this.classList.remove('cart-has-items');
        }

        this.inProgressElement.innerHTML = cart.inprogress_description

        // Calculate how much percentage progress left to get free shipping and set style
        if( cart.progress_percentage ) {
          this.progressBar.style.width = `${cart.progress_percentage}%`;
        }


      }
      ).catch(err => {
        console.error(err);
      })

  }
}

customElements.define('discount-popup', DiscountPopupStatic);
